import React, {useMemo, useState} from "react";
import {Avatar, Stack, Typography} from "@mui/material";
import {Person, SupportAgent} from "@mui/icons-material";
import moment from "moment";
import {DebugMessageModal} from "../../components/DebugMessageModal";


export const MessageBox = ({message, prevMessage, selectedMessage, onSelectMessage, hideStats = false}) => {
  const [selectedDebugMessage, setSelectedDebugMessage] = useState(null);

  const {role, isPrev, isSelected} = useMemo(() => {
    const isPrev = message?.sender === prevMessage?.sender;
    const role = message?.role || message?.sender;
    const isSelected = selectedMessage?.id === message.id;

    return {role, isPrev, isSelected};
  }, [message, prevMessage, selectedMessage]);

  if (role === "AGENT") {
    return (
      <Stack className={"agent-msg"} direction={"column"} alignitems={"flex-start"} gap={1} maxWidth={"md"}>
        {!isPrev && <Avatar size={"small"}
                            sx={{background: "#8491F7", color: "#FFF", width: 35, height: 35}}><SupportAgent/></Avatar>}
        <Stack
          direction={"column"} maxWidth={"sm"}
          onClick={onSelectMessage}
          sx={{
            cursor: onSelectMessage ? "pointer" : "default", p: 1.5,
            borderRadius: 5, borderTopLeftRadius: 5,
            boxShadow: isSelected ? 5 : 0, color: "#FFF", bgcolor: "#8491F7", minWidth: "100px"
          }}
        >
          <Typography fontSize={12} color={"inherit"} gutterBottom>
            {message?.text}
          </Typography>
          {!hideStats && <MessageFooter message={message} color={"#FFFFFF"} />}
        </Stack>

      </Stack>
    )
  }
  if (role === "USER") {
    return (
      <Stack className={"user-msg"} direction={"column"} alignItems={"flex-end"} gap={1} maxWidth={"md"}>
        {!isPrev && <Avatar size={"small"}
                            sx={{background: "#EAEAEA", color: "dark.main", width: 35, height: 35}}><Person/></Avatar>}
        <Stack
          direction={"column"} maxWidth={"sm"}
          onClick={() => onSelectMessage ? onSelectMessage(message) : undefined}
          sx={{
            cursor: onSelectMessage ? "pointer" : "default", p: 1.5,
            borderRadius: 5, borderTopRightRadius: 5,
            boxShadow: isSelected ? 5 : 0, color: "dark.main", bgcolor: "#EAEAEA", minWidth: "100px"
          }}
        >
          <Typography fontSize={12} color={"inherit"} gutterBottom>
            {message?.text}
          </Typography>
          {!hideStats && <MessageFooter message={message} color={"dark.main"} />}
        </Stack>
      </Stack>
    )
  }
  if (hideStats) {
    return null;
  }
  return (
    <>
      <DebugMessageModal
        open={!!selectedDebugMessage}
        handleClose={() => setSelectedDebugMessage(null)}
        debugMessage={selectedDebugMessage}
      />
      <Stack
        onClick={() => setSelectedDebugMessage(message)}
        direction={"column"} maxWidth={"sm"} justifyContent={"center"}
        sx={{
          p: 1.5, minWidth: "100px", mx: "auto", width: "90%",
          color: "dark.main", bgcolor: "#f1f1f1ee", borderRadius: 5,
          cursor: "pointer"
        }}
      >
        <Typography fontSize={12} fontWeight={600}>Debug Message</Typography>
        <Typography fontSize={12} sx={{borderLeft: 2, borderColor: "divider", pl: 1}}>{message?.text?.slice(0, 300)} {message?.text?.length > 300 && "..."}</Typography>
        {!hideStats && <MessageFooter message={message} color={"dark.main"} />}
      </Stack>
    </>

  )
}

const MessageFooter = ({message, color}) => {

  return (
    <>
      <Stack direction={"row"} gap={1} sx={{color: color || "inherit", width: "95%"}}>
        {message?.responseTime?.chatbot && <Typography fontSize={11}
                                                       color={color || "inherit"}>Chatbot: {(message?.responseTime?.chatbot / 1000)?.toFixed(2) || ""}s</Typography>}
        {message?.responseTime?.transcribe && <Typography fontSize={11}
                                                          color={color || "inherit"}>Transcribe: {(message?.responseTime?.transcribe / 1000)?.toFixed(2) || ""}s</Typography>}
        {message?.responseTime?.synthesize && <Typography fontSize={11}
                                                          color={color || "inherit"}>Synthesize: {(message?.responseTime?.synthesize / 1000)?.toFixed(2) || ""}s</Typography>}
        <Typography sx={{ml: "auto"}} fontSize={11} color={color || "inherit"}>
          {moment(message?.dateCreated)?.format("HH:mm:ss")}
        </Typography>
      </Stack>
    </>
  )
}